export default "__VITE_ASSET__B649WyGy__"